<template>
    <div>
        <div class="form-group text-muted">
          <label>ID: </label>
          {{data.id}}
        </div>
        <text-input :value="data.name" label="Name" ref="name"></text-input>
        <long-text-input :value="data.description" label="Kurzbeschreibung"
                            ref="description"></long-text-input>
        <long-text-input :value="data.longDescription" label="Kurztitel"
                            ref="longDescription"></long-text-input>
        <div class="form-group">
            <label for="#card-type">Art der Anordnung</label>
            <multiselect id="card-type" v-model="type"
                        label="label"
                        :options="typeOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <div class="form-group">
            <label for="#card-illustration-type">Art der Illustration</label>
            <multiselect id="card-illustration-type" v-model="illustrationType"
                        label="label"
                        :options="illustrationTypeOptions"
                        :show-labels="false">
            </multiselect>
        </div>
        <div class="form-group" v-if="illustrationTypeValue === 'component'">
            <label for="#card-illustration-component">Illustrations-Komponente</label>
            <input type="text" class="form-control" v-model="illustrationComponentValue" id="card-illustration-component">
        </div>
        <div class="form-group">
            <label for="#card-size">Grösse</label>
            <multiselect id="card-size" v-model="size"
                        :options="[1, 2]"
                        :show-labels="false">
            </multiselect>
        </div>
        <entity-multiselect
                entity="tag"
                label="Tags"
                :value="tagIds"
                @input="changedTags"
                name="tags"></entity-multiselect>
        <label><input type="checkbox" v-model="showPreview"> Benutze zweites Bild als Vorschau</label>
        <file-input v-model="data.images" label="Bilder" type="image" :max-files="12"/>
        <div class="admin-info mb-3">
            <p>Das erste Bild wird als Titelbild verwendet, die anderen Bilder können in den Texten eingebunden werden
                mit dem Code</p>
            <pre>[img id=ID align=[left|right|center] size=[1|2|3]]</pre>
            <p>Das zweite Bild wird als Previewbild verwendet, falls die "Benutze zweites Bild als Vorschau" aktiviert ist.</p>
            <p>Referenzen können erfasst werden mit dem Code</p>
            <pre>[ref type=[project|umbrella-project|result|url] id=ID url=URL]Beschreibungstext[/ref]</pre>
            <p>Footnotes können erfasst werden mit dem Code</p>
            <pre>[footnote]Footnotetext[/footnote]</pre>
            <p>Inline-Bilder können erfasst werden mit dem Code</p>
            <pre>[collapse-img id=ID][/collapse-img]</pre>
            <p>Inline-Produkte können erfasst werden mit dem Code</p>
            <pre>[result-list ids="COMMA_SEPARATED_IDS"]Titel[/result-list]</pre>
            <p>
              Bitte beachte dass der Footnotetext ebenfalls referenzen beinhalten kann. Zusätzlich können Referenzen
              und Footnotes auch in der Beschreibung und der Quellenangabe von Bildern eingefügt werden.
            </p>
            <pre>Die URL muss nur für den Typ "url" angegeben werden.</pre>
        </div>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: ['data', 'isSubchapter'],
  data() {
    return {
      showPreview: this.data.showPreview,
      tagIds: this.data.tagIds,
      typeValue: this.data.type,
      illustrationTypeValue: this.data.illustrationType,
      illustrationComponentValue: this.data.illustrationComponent,
      sizeValue: this.data.size,
      typeOptions: [
        { value: 'full', label: "Ganze Breite" },
        { value: 'half', label: "Halbe Breite" },
        { value: 'half_full', label: "Bild halbe Breite, Text ganze Breite" },
      ],
      illustrationTypeOptions: [
        { value: 'picture', label: "Bild" },
        { value: 'component', label: "Komponente" }
      ]
    }
  },
  computed: {
    type: {
      get() {
        return this.typeOptions.find(option => option.value === this.typeValue);
      },
      set(typeOption) {
        this.typeValue = typeOption.value;
      }
    },
    illustrationType: {
      get() {
        return this.illustrationTypeOptions.find(option => option.value === this.illustrationTypeValue);
      },
      set(typeOption) {
        this.illustrationTypeValue = typeOption.value;
      }
    },
    size: {
      get() {
        return this.sizeValue + 1;
      },
      set(value) {
        this.sizeValue = value - 1;
      }
    }
  },
  methods: {
    changedTags(value) {
      this.tagIds = value;
    },
    saveCard() {
      let form = new FormData();
      const form_prefix = 'edit_card';
      form.append(form_prefix + "[size]", this.sizeValue);
      form.append(form_prefix + "[type]", this.typeValue);
      form.append(form_prefix + "[illustrationType]", this.illustrationTypeValue);
      form.append(form_prefix + "[illustrationComponent]", this.illustrationComponentValue);
      form.append(form_prefix + "[name]", this.data.name.text);
      form.append(form_prefix + "[subChapter]", this.data.subChapterId || '');

      if(this.showPreview)
        form.append(form_prefix + "[showPreview]", this.showPreview);

      for (let id of this.tagIds) {
        form.append(form_prefix + "[tags][]", id);
      }
      for (let i = 0; i < this.data.images.length; i++) {
        form.append(
          form_prefix + "[images][" + i + "]",
          this.data.images[i].id
        );
      }
      form.set(form_prefix + "[submit]", null);
      return axios.post(
        `/api/${store.state.language}/card/${this.data.id}/edit`,
        form
      );
    },
    save() {
      store.commit("addSavingProcess");
      Promise.all([
        this.saveCard(),
        this.$refs.name.save(),
        this.$refs.description.save(),
        this.$refs.longDescription.save()
      ]).then(({ data }) => {
          store.commit("finishSavingProcess");
        })
        .catch(err => {
          store.commit("finishSavingProcess");
          alert(
            "Beim Speichern ist ein Fehler aufgetreten."
          );
        });
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/card/General.vue